import type { FAQ } from './types';

export const faqs: FAQ[] = [
  {
    question: '福利导航网站上的信息多久更新一次？',
    answer: '我们的编辑团队每日更新各类福利信息。折扣优惠信息通常在活动开始前1-3天发布；政府补贴政策在官方发布后24小时内更新；会员权益信息每月进行一次全面核查。建议您收藏本站并开启通知，第一时间获取最新福利资讯。',
  },
  {
    question: '网站上的优惠信息是否都经过验证？',
    answer: '是的。我们所有发布的优惠信息都经过人工核实。我们的编辑团队会逐一验证优惠链接的有效性、活动时间、参与条件和实际优惠力度。对于政府补贴类信息，我们会直接引用官方发布的原始文件作为依据。如果发现信息有误，欢迎通过"联系我们"页面反馈。',
  },
  {
    question: '如何使用福利导航找到最适合我的福利？',
    answer: '您可以通过以下方式快速找到适合自己的福利：1）使用顶部导航栏按分类浏览（折扣优惠、会员权益、生活补贴、职场福利等）；2）使用搜索功能输入关键词查找；3）关注首页"热门推荐"栏目查看精选内容；4）订阅我们的新闻通讯，每周获取精选福利推送。',
  },
  {
    question: '福利导航提供的信息是否免费？',
    answer: '完全免费！福利导航是一个公益性质的信息聚合平台，所有内容对用户完全开放。我们没有任何付费墙或会员制度。部分福利信息可能包含推广链接，但这不影响信息的真实性和客观性。',
  },
  {
    question: '如何订阅福利导航的最新资讯？',
    answer: '您可以通过页面底部的新闻通讯订阅表单，输入您的电子邮箱即可订阅。我们每周发送一封精选福利汇总邮件，包含当周最热门的优惠信息和新发布的福利政策。我们承诺不会向第三方分享您的邮箱地址，并且您可以随时取消订阅。',
  },
  {
    question: '我发现了好的福利信息，如何分享给更多人？',
    answer: '非常感谢您的分享精神！您可以通过"联系我们"页面提交您发现的福利信息，我们的编辑团队审核通过后会署名发布。您也可以直接将文章分享到微信、微博等社交平台，帮助更多朋友享受福利。',
  },
];